import { render, staticRenderFns } from "./fusePurchaseOrderTrace.vue?vue&type=template&id=568e2415&scoped=true"
import script from "./fusePurchaseOrderTrace.vue?vue&type=script&lang=js"
export * from "./fusePurchaseOrderTrace.vue?vue&type=script&lang=js"
import style0 from "./fusePurchaseOrderTrace.vue?vue&type=style&index=0&id=568e2415&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e2415",
  null
  
)

export default component.exports